import * as types from './types';

const INITIAL_STATE = {
  timeZones: [],

  /** User's UTC offset in minutes */
  offsetMinutes: {
    loading: false,
    error: null,
    data: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_TIMEZONES:
      return {
        ...state,
        timeZones: action.payload,
      };

    case types.GET_OFFSET_MINUTES_LOADING:
      return {
        ...state,
        offsetMinutes: {
          ...state.offsetMinutes,
          loading: action.payload,
        },
      };
    case types.GET_OFFSET_MINUTES:
      return {
        ...state,
        offsetMinutes: {
          ...state.offsetMinutes,
          data: action.payload,
        },
      };
    case types.GET_OFFSET_MINUTES_ERROR:
      return {
        ...state,
        offsetMinutes: {
          ...state.offsetMinutes,
          error: action.payload,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/timeZones/reducer.js